import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicAgenda from "@/pages/PublicAgenda";
import AdminLogin from "@/pages/AdminLogin";
import AdminAgenda from "@/pages/AdminAgenda";
import AdminSettings from "@/pages/AdminSettings";
import AdminEmails from "@/pages/AdminEmails";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
    const { user, ready } = useAuth();
    if (!ready) return <div className="p-8 text-center text-gray-500">Caricamento…</div>;
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PublicAgenda />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<ProtectedRoute><AdminAgenda /></ProtectedRoute>} />
                    <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
                    <Route path="/admin/emails" element={<ProtectedRoute><AdminEmails /></ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </AuthProvider>
    );
}

export default App;
